/*=========================================================================================
  File Name: moduleCustomerState.js
  Description: Customer Module State
==========================================================================================*/

export default {
	customers: [],
	customersSearchQuery: "",
	customersFilter: null,
	total: 0,
	limitPerPage: 10,
	debts: [],
	debtsTotal: 0,
	showProducts: [],
	debtsReportExcel: null,
	acccessableFields: [],
	pipelines: [],
	totalShowProducts: 0
};
